export default __webpack_public_path__ + "static/media/charco-security.6927e276.svg";